import { AppPage } from 'src/components/AppPage';
import { TestId } from 'src/testids';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Feedback } from 'src/components';
import { DevicesTable } from '../components/DevicesTable';
import { Overview } from '../components/Overview';

export function EnterpriseDevicesPage() {
  return (
    <>
      <AppPage.Header
        className="w-full justify-start px-16 text-left lm:px-32"
        title="Devices"
      />
      <AppPage.Content
        className="max-w-l2xl"
        data-cy={TestId.PageEnterpriseMembers}
      >
        <div className="flex flex-col gap-32">
          <Overview
            componentLocation={ComponentLocations.ENTERPRISE.DEVICES_PAGE}
          />

          <DevicesTable />
        </div>
        <Feedback
          feedbackTargetId="enterprise-devices-page"
          title="Did you find what you were looking for?"
        />
      </AppPage.Content>
    </>
  );
}
